import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const OnboardingOrderPreview = ApplicationRecord.extend({
  attrs: {
    code_string: attr({ type: String }),
    delivery_date: attr({ type: String }),
    delivery_option_id: attr({ type: Number }),
    recipe_contents: attr(),

    // Recipe Preview
    recipe_discount_amount: attr({ type: String, persist: false }),
    recipe_external_payment_amount: attr({ type: String, persist: false }),
    recipe_shipping_amount: attr({ type: String, persist: false }),
    recipe_standard_shipping_amount: attr({ type: String, persist: false }),
    recipe_purchase_value: attr({ type: String, persist: false }),
  },
  static: {
    endpoint: '/onboarding_order_previews',
    jsonapiType: 'payments-onboarding_order_previews',
  },
});

export default OnboardingOrderPreview;
